module.exports = __webpack_public_path__ + "static/media/MasterAccount.7a34f262.svg";